class Form {
  constructor(element, options) {
    this._options = { ...Form.options, ...options };
    this._element = element;
    this._initFields = this._initFields.bind(this);
    this._setTextarea = this._setTextarea.bind(this);
    this._textareaEvents = ['change', 'keyup', 'paste'];
    this._init();
  }

  _init() {
    this._cacheSelectors();
    this._initFields();
  }

  _cacheSelectors() {
    this._fields = [...this._element.querySelectorAll('input.FormTextbox__Input, select')];
    this._textarea = [...this._element.querySelectorAll('textarea')];
    this._selects = [...this._element.querySelectorAll('select')];
    // this._numbers = [...this._element.querySelectorAll('[type="number"]')]
    // this._checkboxes = [
    //   ...this._element.querySelectorAll('input[type="checkbox"]')
    // ]
    // this._radios = [...this._element.querySelectorAll('input[type="radio"]')]
  }

  _setTextarea(textarea) {
    if (this._options.disableTextareaSizing === 'true') {
      return false;
    }

    const compStyles = window.getComputedStyle(textarea);
    const lineheight = parseInt(compStyles.getPropertyValue('line-height'), 10);
    const paddingtop = parseInt(compStyles.getPropertyValue('padding-top'), 10);
    const paddingbottom = parseInt(compStyles.getPropertyValue('padding-bottom'), 10);
    const lines = textarea.value.split('\n').length;
    const height = lines * lineheight + paddingtop + paddingbottom;
    textarea.style.height = `${height}px`;

    return true;
  }

  _setSelect = (select) => {
    if (select.selectedIndex) {
      select.setAttribute('data-selected', true);
    } else {
      select.setAttribute('data-selected', false);
    }
  };

  _initFields() {
    this._textarea.forEach((textarea) => {
      this._setTextarea(textarea);
      this._textareaEvents.forEach((event) => {
        textarea.addEventListener(
          event,
          () => {
            this._setTextarea(textarea);
          },
          true
        );
      });
    });

    this._selects.forEach((select) => {
      this._setSelect(select);
      select.addEventListener(
        'change',
        () => {
          this._setSelect(select);
        },
        true
      );
    });

    this._fields.forEach((input) => {
      const error = input.parentNode.querySelector('.Form__Element__ValidationError');
      /* eslint-disable no-unused-expressions */
      error.textContent.length > 0
        ? input.parentNode.setAttribute('data-error', true)
        : input.parentNode.setAttribute('data-error', false);
      /* eslint-enable */
    });
  }
}

export default Form;
